import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { useIsSecureGuest } from 'src/app/shared/hooks/payments';

type Result = ModelHookResult<
	{
		displayed: boolean;
		isPublic: boolean;
		label: string;
	},
	{ setPublic: (isPublic: boolean) => void }
>;

export function usePublicInput(): Result {
	const [{ isPublic }, { setPublic }] = usePromotePageState();
	const {
		data: {
			featureConfigs: { useDonationLanguage, doubleOptinEnabledNewUser },
		},
	} = usePromotePageData();
	const { translate } = useI18n();

	const isSecureGuest = useIsSecureGuest(doubleOptinEnabledNewUser);

	return {
		data: {
			displayed: !isSecureGuest,
			isPublic,
			label: translate(`corgi.co.promote.public_opt_in_label${useDonationLanguage ? '_donation' : ''}`),
		},
		actions: {
			setPublic,
		},
	};
}
